export default __webpack_public_path__ + "img/bg-white.b80f3b6e.jpg";